import { isCropSupportedForNutrition } from "@omnia/shared/nutrition"
import { nutrients } from "../../../nutrients"
import { defineDirective, IOmniaSession, IOmniaSettings } from "../../../omnia"
import { setupStocks } from "../../../stocks/utils"
import { INutritionService, NutrientType } from "../../../types"
import { applyPlanFilter, comparePlansOrder } from "../../../utils"
import { TableDashboardContext } from "../dashboardContext"
import { PlanCroppingVm } from "../vm/planCroppingVm"
import { PlanVm } from "../vm/planVm"

export function createDashboard(): ng.IDirective {

    return defineDirective(PlansDashboardCtrl, "app/nutrition/dashboard/table/plans/plans.html", {
        dashboard: "<",
        filter: "<"
    })

}


export class PlansDashboardCtrl {

    static $inject = ["$scope", "OmniaNutritionService", "OmniaSession"]

    settings: IOmniaSettings

    public dashboard: TableDashboardContext
    public plans: PlanVm[] = []
    public visiblePlans: PlanVm[] = []

    private _filter: string

    private _allCropping: PlanCroppingVm[]


    constructor(private $scope: ng.IScope, private svc: INutritionService, session: IOmniaSession) {

        this.settings = session.getSettings("nutrition.plans")

        this.$scope.$watch("vm.dashboard", () => this.setup())

    }

    protected setup() {

        this.setupPlans()
        this.setupCropping()

    }

    protected setupCropping() {

        var cropping = this.svc.cropping

        cropping = cropping.filter(c => isCropSupportedForNutrition(c))

        this._allCropping = PlanCroppingVm.createFromCropping(this.svc, cropping, this.plans)

    }

    protected setupPlans() {

        const plans = this.svc.getPlans()

        const stocks = setupStocks(this.svc)

        this.plans = plans
            .sort(comparePlansOrder)
            .map(p => new PlanVm(p, this.svc, stocks))

        this.applyPlanFilter()

    }

    private applyPlanFilter() {

        const { filter } = this

        const plans = this.plans.filter(p => p.visible)

        this.visiblePlans = applyPlanFilter(
            plans,
            p => p.planInfo,
            filter
        )

    }

    get filter() {
        return this._filter
    }

    set filter(value) {
        this._filter = value
        this.applyPlanFilter()
    }

    canCreateNewPlan(): boolean {

        if (!this._allCropping) return false

        return this._allCropping.some(c => !!c.requirements)

    }

    createNewPlan(cropping: PlanCroppingVm[]) {
        return this.dashboard.createNewPlan(cropping)
    }

    editPlan(planVm: PlanVm) {
        this.dashboard.updatePlan(planVm, null)
    }

    public getNutrientName(nutrient: NutrientType): string {
        if (!nutrient) return null
        return nutrients.find(n => n.value === nutrient).text
    }
}
